import { Banner } from '@sunwebgroup/uds-ui/banner'
import { RichText } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { BannerType } from '@/scopes/common/domain/types/banner'
import { pricesResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

const RichTextStyled = styled(RichText)`
  max-width: initial;
`

const BannerContentWrapper = styled(Banner.ContentWrapper)`
  flex-direction: column;
`

function mapMessageLevelToColor(level: BannerType) {
  switch (level) {
    case 'info':
      return 'informative'
    case 'warning':
      return 'warning'
    case 'error':
      return 'danger'
    default:
      return 'neutral'
  }
}

export function Messages() {
  const { messages } = usePricesSelector(pricesResponseSelector)
  if (!messages)
    return null
  return messages.map((message, index) => (
    <Banner color={mapMessageLevelToColor(message.level)} hasIcon={false} size="S" key={index}>
      <BannerContentWrapper>
        {message.texts.map((text, _) => (
          <Banner.SupportingText key={_}>
            <RichTextStyled innerHTML={text} />
          </Banner.SupportingText>
        ))}
      </BannerContentWrapper>
    </Banner>
  ))
}
